module.exports = __webpack_public_path__ + "static/modal-birmingham-91a839ee8a8f15d175d94014fe5bc1dc.jpg";